import { Caption, Flex, generateNameHash } from '@kvdbil/components';
import React, { ReactNode, useRef, useState } from 'react';
import { Collapse } from 'react-collapse';
import styled from 'styled-components';
import { Info } from '~/App/shared/components/IconButtons/Info';

export type AlignType =
  | 'center'
  | 'end'
  | 'start'
  | 'justify'
  | 'left'
  | 'right'
  | 'inherit'
  | 'initial'
  | 'unset';

const Content = styled.div<{ alignContent: AlignType }>`
  text-align: ${({ alignContent }) => alignContent};
  padding: 0.5rem 0;
`;

export interface ToolTipProps {
  centered?: boolean;
  label: ReactNode | string;
  content: ReactNode | string;
  alignContent?: AlignType;
}
export const ToolTip = ({
  label,
  content,
  centered = false,
  alignContent = 'center'
}: ToolTipProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const idRef = useRef(generateNameHash('res-price-info-content'));

  const toggleOpen = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <>
      <Flex gap={0.5} justify={centered ? 'center' : 'left'}>
        <Caption as="span">{label}</Caption>
        <Info
          isInfoOpened={isOpen}
          onClick={toggleOpen}
          ariaControls={idRef.current}
          iconSize={1.25}
        />
      </Flex>
      <Collapse isOpened={isOpen}>
        <Content id={idRef.current} alignContent={alignContent}>
          {content}
        </Content>
      </Collapse>
    </>
  );
};

export default ToolTip;
